import { useLocation } from 'react-router-dom';
import { getLanguageFromPath, localizePath } from '../../utils';

// Returns a function that prefixes app paths with the current URL language
export const useLocalizedPath = () => {
  const { pathname } = useLocation();
  const language = getLanguageFromPath(pathname);

  return (path: string) => localizePath(path, language);
};
